// frontend/src/App.jsx
import React, { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { authAPI } from './api/client';

// Import all components
import Welcome from './components/Auth/Welcome';
import Login from './components/Auth/Login';
import SchoolInfo from './components/Auth/Registration/SchoolInfo';
import UsernameStep from './components/Auth/Registration/UsernameStep';
import EmailVerification from './components/Auth/Registration/EmailVerification';
import StudentInfo from './components/Auth/Registration/StudentInfo';
import AvatarSelection from './components/Auth/Registration/AvatarSelection';
import ConceptSelection from './components/Concepts/ConceptSelection';
import Dashboard from './components/Dashboard/Dashboard';
import StudentDashboard from './components/Dashboard/StudentDashboard';
import GamifiedPractice from './components/Practice/GamifiedPractice';
import DailyAssessment from './components/Assessment/DailyAssessment';
import Assessment from './components/Assessment/Assessment';
import SelectPracticeConcept from './components/Practice/SelectPracticeConcept';
import ManageConcepts from './components/Parent/ManageConcepts';
import Profile from './components/Profile/Profile';
import StudentResults from './components/Assessment/StudentResults'; // ✅ Add this import

function App() {
    const [loading, setLoading] = useState(true);
    const [isAuthenticated, setIsAuthenticated] = useState(false);

    useEffect(() => {
        const checkAuth = async () => {
            try {
                const response = await authAPI.checkAuth();
                if (response.is_authenticated) {
                    setIsAuthenticated(true);
                }
            } catch (error) {
                console.error('Auth check failed:', error);
            } finally {
                setLoading(false);
            }
        };
        checkAuth();
    }, []);

    if (loading) {
        return (
            <div style={{ 
                display: 'flex', 
                justifyContent: 'center', 
                alignItems: 'center', 
                height: '100vh',
                fontSize: '20px'
            }}>
                Loading SolveSmart...
            </div>
        );
    }

    return (
        <BrowserRouter>
            <Routes>
                {/* Public Routes */}
                <Route path="/" element={<Welcome />} />
                <Route path="/login" element={<Login />} />
                
                {/* Registration Flow Routes */}
                <Route path="/school-info" element={<SchoolInfo />} />
                <Route path="/username" element={<UsernameStep />} />
                <Route path="/email-verification" element={<EmailVerification />} />
                <Route path="/student-info" element={<StudentInfo />} />
                <Route path="/avatar-selection" element={<AvatarSelection />} />
                
                {/* Concept Selection Route */}
                <Route path="/concept-selection" element={<ConceptSelection />} />
                <Route path="/parent-dashboard" element={<Dashboard />} />
                <Route path="/assessment" element={<Assessment />} />
                <Route path="/gamified-practice" element={<GamifiedPractice />} />
                <Route path="/daily-assessment" element={<DailyAssessment />} />
                <Route path="/dashboard" element={<StudentDashboard />} />
                <Route path="/select-practice-concept" element={<SelectPracticeConcept />} />
                <Route path="/parent-manage-concepts" element={<ManageConcepts />} />
                <Route path="/profile" element={<Profile />} />
                
                {/* ✅ Add Results Route */}
                <Route path="/results" element={<StudentResults />} />
                <Route path="/results/:assessmentId" element={<StudentResults />} /> {/* Optional: with ID parameter */}
                
                {/* Protected Routes */}
                <Route path="/dashboard" element={isAuthenticated ? <div>Dashboard</div> : <Navigate to="/login" />} />
                
                {/* Fallback */}
                <Route path="*" element={<Navigate to="/" />} />
            </Routes>
        </BrowserRouter>
    );
}

export default App;